import * as moment from 'moment';
import { AppConsts } from '@shared/AppConsts';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Type, CompilerOptions, NgModuleRef } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { MultiTenancyService } from '@shared/multi-tenancy/mult-tenancy.service';
import { AppStorageService } from '@shared/storage/app-storage.service';
import { InterceptorSkipHeader } from '@shared/app-http-interceptor';
import { AppSessionService } from '@shared/session/app-session.service';

export class AppPreBootstrap {

    token: string;
    constructor(
        private http: HttpClient,
        private multiTenantService: MultiTenancyService,
        private storageService: AppStorageService,
        private appSessionService: AppSessionService
    ) {
        storageService.TokenSubject.subscribe(t => {
            this.token = t;
            this.getUserConfiguration(() => { }).then();
        });
    }
    async run(appRootUrl: string, callback: () => void): Promise<void> {
        await this.storageService.init().then(() => {
            this.getUserConfiguration(callback);
        })

    }

    bootstrap<TM>(moduleType: Type<TM>, compilerOptions?: CompilerOptions | CompilerOptions[]): Promise<NgModuleRef<TM>> {
        return platformBrowserDynamic().bootstrapModule(moduleType, compilerOptions);
    }

    private getApplicationConfig(appRootUrl: string, callback: () => void) {
        return this.http.get(
            appRootUrl + '/assets/' + environment.appConfig,
            {
                headers: {
                    'Abp.TenantId': this.multiTenantService.getTenantIdCookie()
                }
            }).subscribe((result: any) => {
                AppConsts.appBaseUrl = result.appBaseUrl;
                AppConsts.remoteServiceBaseUrl = result.remoteServiceBaseUrl;
                AppConsts.localeMappings = result.localeMappings;

                callback();
            });
    }


    private getUserConfiguration(callback: () => void): Promise<any> {
        if (this.token) {
            this.appSessionService.init();
            return this.http.get(
                AppConsts.remoteServiceBaseUrl + '/AbpUserConfiguration/GetAll',
                {
                    headers: {
                        InterceptorSkipHeader: InterceptorSkipHeader,
                        Authorization: 'Bearer ' + this.token,
                        // '.AspNetCore.Culture': this.utilService.getCookieValue('Abp.Localization.CultureName'),
                        'Abp.TenantId': this.multiTenantService.getTenantIdCookie()
                    }
                }).toPromise().then((result: any) => {
                    this.storageService.setAllPermissions(result.result.auth.allPermissions);
                    this.storageService.setGrantedPermissions(result.result.auth.grantedPermissions);
                    if (callback)
                        callback();
                });
        }
        return Promise.resolve();
    }
}
